import React, { useState, useEffect } from 'react'
import Formulario from 'components/formulario';
import { Search } from '@mui/icons-material';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import { obtenerRegistrosPorURL } from 'store/actions/customAction';
import { useDispatch } from 'react-redux';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import PlanDeMediosIntegradoTimeline from '.';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import { generarDatosJson } from './builders';
import { functions } from 'constantes/functions';
import { TablePagination } from '@mui/material';

export default function BuscadorTimeline({eventoActual}) {
  const dispatch = useDispatch();
  const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
  const[generarReportes] = useState("generarReportes");
  const[datosDelFiltro, setDatosDelFiltro] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(1500);
  const [datosDelFormulario, setDatosDelFormulario] = useState({tipoDeMedio:{}, idEvento: {}})

  useEffect( () => {
    buscarFiltro(datosDelFormulario)
  }, [page])

  const handleChangePage = (event, newPage) => { setPage(newPage); };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [camposDelFormulario] = useState({
    tipoDeMedio: {
      idelement: "tipoDeMedio", value: null, label: "Tipo de medio *", pattern:"^[1-9][0-9]*$", validators: ['required'],
      errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [{id: 1, name: "TELEVISION"}, {id: 2, name: "RADIO"}, {id: 3, name: "ESCRITOS"}], handler: undefined, width: "49%"
    },
    idEvento: {
      idelement: "idEvento", value: eventoActual, label: "Seleccione el evento *", pattern:"^[1-9][0-9]*$", validators: ['required'],
      errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [eventoActual], handler: undefined, width: "49%", disabled: true
    },
  });

  const accionBuscarFiltro = (datosFormulario) => {
    setPage(0)
    buscarFiltro(datosFormulario);
  }

  const buscarFiltro = async (datosFormulario) => {
    const { tipoDeMedio, idEvento} = datosFormulario;

    if(!tipoDeMedio?.id) return;
    setcargandoSolicitud(true);
    setDatosDelFiltro([]);
    setDatosDelFormulario({tipoDeMedio, idEvento})

    const parametro = `generarFlowChartJson/${idEvento?.id}/${tipoDeMedio?.id}/${page}/${rowsPerPage}`

    ServiciosDelAPI[generarReportes].metodoDeBusqueda.clear();
    ServiciosDelAPI[generarReportes].metodoDeOrden.clear();

    const respuesta = await dispatch(obtenerRegistrosPorURL({ controller: generarReportes, saveInStore: false, nombreDelMetodo: "listar", parametro}));
    setcargandoSolicitud(false);

    if(respuesta?.error) return alertaPersonalizadaSwal(respuesta?.error?.message || "¡No se pudó obtener la información del reporte!",'')
    if(!respuesta?.data) return alertaPersonalizadaSwal("¡No hay datos para el reporte seleccionado!",'')
    if(respuesta?.data?.content?.length === 0) alertaPersonalizadaSwal("¡No hay datos!",'')

    let datosOrdenadors = [];

    if(respuesta?.data?.content?.length > 0) {
      const datosGenerados = generarDatosJson(respuesta?.data?.content || [])
      datosOrdenadors = functions.ordenarArreglo(datosGenerados, 'idCobertura')
    }

    setDatosDelFiltro(datosOrdenadors)
  }

  const [listadoBotones2]= useState({
    "saveData":{"label":"Buscar plan de medios seleccionado", "icon": <Search />, "callback":accionBuscarFiltro, "loading":false, "size":"medium", "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", color:"white", "height":37, padding:"0 30px", disabled: false, isCancel: false,
    }
  });

  return (
    <>
      {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }

      <Formulario
        elements={camposDelFormulario}
        buttonList={listadoBotones2}
      />
      {datosDelFiltro?.length > 0 ? (
        <>
          <TablePagination
            component="div"
            count={-1}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            color="primary"
            size="large"
            showFirstButton
            showLastButton
            labelRowsPerPage="Filas por pagina"
            labelDisplayedRows= {
              ({ from, to }) => `Registros ${from} al ${to}`
            }
          />
          <PlanDeMediosIntegradoTimeline datosDelFiltro={datosDelFiltro} />
        </>
      ) : null}
    </>
  )
}